export const usersSubscriptionGroupDoubleOptInEnabled = "/users/subscription_group/double_opt_in_enabled";
